import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from '../shared/validators/password.validator';
import { EMAIL_TLD_PATTERN } from '../shared/validators/email.validator';

@Injectable({
  providedIn: 'root',
})
export class CreateAccountPresenter {
  constructor(private formBuilder: FormBuilder) { }

  initializeCreateAccountForm() {
    return this.formBuilder.group(
      {
        email: [null, [Validators.required, Validators.email, Validators.pattern(EMAIL_TLD_PATTERN)]],
        tempPassword: [null, [Validators.required]],
        password: [null, [Validators.required, passwordValidator()]],
        confirmPassword: [null, [Validators.required]],
        userName: [null, [Validators.required]],
        dateOfBirth: [null, [Validators.required, this.minimumAgeValidator(18)]],
      },
      { validator: this.passwordMatchValidator },
    );
  }

  minimumAgeValidator(minAge: number) {
    return (control: AbstractControl) => {
      // Validators.required owns the empty case; returning null here keeps the
      // two errors from stacking on an untouched field.
      if (!control.value) {
        return null;
      }

      const today = new Date();
      // A date-only ISO string ("2008-09-08") parses as UTC, which lands on the
      // previous day in any negative-offset timezone and let someone exactly one
      // day short of the minimum through. Appending a time forces local parsing.
      const birthDate = new Date(control.value + 'T00:00:00');
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      const dayDifference = today.getDate() - birthDate.getDate();

      // Check if the user is under 18
      if (
        age < minAge ||
        (age === minAge && (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)))
      ) {
        return { underage: true };
      }
      return null;  // Valid
    };
  }


  passwordMatchValidator(group: FormGroup) {
    const passwordControl = group.get('password');
    const confirmPasswordControl = group.get('confirmPassword');

    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordsMismatch']) {
      // Return if another validator has already found an error on the confirmPasswordControl
      return;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordsMismatch: true });
    } else {
      confirmPasswordControl.setErrors(null);
    }
  }

}
